fx.ns("models", class CreationElementContent extends fx.Model {

	constructor(data, options)
	{
		super(data, options);

		this._labels = {
			text : fx.text("Ajouter un texte"),
			title : fx.text("Ajouter un TITRE"),
			"slice-text" : ""
		}
	}

	get isPhoto()
	{
		return this.component_type == "photo" || this.component_type == "image";
	}

	get isShape()
	{
		return this.component_type == "shape";
	}

	get isText()
	{
		return this.component_type == "text";
	}

	get isBackground()
	{
		return this.component_type == "background";
	}

	get isSticker()
	{
		return this.component_type == "sticker";
	}

	get propertiesNotStorable()
    {
        return ["id", "area"];
	}
	
	get isSliceText()
	{
		return this.isText && this.content_type == "slice-text";
	}

	get isPagination()
	{
		return this.component_type == "pagination";
	}

	duplicate()
	{
		let data = this.JSON;
		data.id = "";
		return new models.CreationElementContent(data);
	}


	contentLabel()
	{
		return this._labels[this.content_type] || "";
	}

	 // set here defaults value that will be used when creating new model
	 get defaults()
	 {
		 return {    zoom : 1,
					 font_family : 1,
					 font_size : 12,
					 align : "left",
					 text_style : "",
					 text_color : "rgba(0,0,0,1)",
					 content : "",
					 component_type:"",
					 x : 0,
					 y : 0,
					 x_inner : 0,
					 y_inner : 0,
					 width : 0,
					 height : 0,
					 width_inner : 0,
					 height_inner : 0,
					 rotation : 0,
					 rotation_inner : 0,
					 level : 0,
					 creation : "",
					 borderid : 0,
					 bgcolor : "rgba(0,0,0,0)",
					 effectName : "",
					 luminosity: 0,
					 saturation: 0,
					 contrast: 0,
					 photomask : "",
					 side : "",
				 };
	 }

	 

});